module.exports = __webpack_public_path__ + "06_mustache_brown.65d542f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/06_mustache_brown.png
// module id = 8btL
// module chunks = 0